import { fetchApi } from '../api/userProfileManager';
export default async (logger) => {
    const res = await fetchApi({}, `profile/{userId}/avatar`, logger);
    return {
        hashCode: res.headers.get('etag')?.replace(/"/g, ''),
        data: await res.blob(),
    };
};
